var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterSearchBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 34V38H18V34H6ZM6 10V14H26V10H6ZM26 42V38H42V34H26V30H22V42H26ZM14 18V22H6V26H14V30H18V18H14ZM42 26V22H22V26H42ZM30 18H34V14H42V10H34V6H30V18Z",
    fill: "#687484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSearchBox);
export default __webpack_public_path__ + "static/media/filterSearchBox.f8613c9fa340e987d4fc056f54dabc58.svg";
export { ForwardRef as ReactComponent };